import React, {useState} from 'react'

import {Segment, Grid,Divider, Button, Icon} from 'semantic-ui-react'

import PlayerScoreTable from './PlayerScoreTable'

import {useMeleeContext} from '../../draft/context/MeleeContextProvider'



const Dashboard = (props:{
    showCompletedGames: boolean
    setShowCompletedGames: (isShowing: boolean) => void
}) => {
    const [scoreBoardOpen, setScoreBoardOpen] = useState(false);

    const ctx = useMeleeContext();
    if(!ctx) return <></>

    const tournament = ctx.tournament;

    const toggleShowCompleteMatchesButton = () =>{
        return(
            <Button basic icon 
                className='melee' 
                size='small'
                onClick={() => props.setShowCompletedGames(!props.showCompletedGames)}
            ><Icon name={props.showCompletedGames ? 'hide' : 'unhide'}/>
                {props.showCompletedGames ? 'Hide' : 'Show'} Completed Matches
            </Button>
        )
    }
    
    return (
        <>
        <Divider horizontal style={{color:'white'}}>Dashboard</Divider>

        <Segment style={{backgroundColor:'transparent'}}>
            <Grid columns='equal' style={{paddingBottom:'2em'}} stackable>
                <Grid.Column style={{margin:'auto'}}>
                   {toggleShowCompleteMatchesButton()}
                </Grid.Column>
                <Grid.Column>

                <input
                    value={ctx.searchText}
                    onChange={(e) => ctx.setSearchText(e.target.value)}
                    placeholder={'Search'}
                />
                
                </Grid.Column>
                <Grid.Column style={{margin:'auto'}}>
                    <Button onClick={() => setScoreBoardOpen(!scoreBoardOpen) } 
                    basic size='medium' 
                    className="melee"
                ><Icon name='list ol'/>{scoreBoardOpen ? 'Hide Scoreboard' : 'Show Scoreboard'}</Button>
                </Grid.Column>
            </Grid>

            {tournament.Players && scoreBoardOpen &&
                <PlayerScoreTable />
            }

        </Segment>
        </>
    )
}

export default Dashboard;